// src/pages/roles/VolunteerList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import roleService from '../../services/roleService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import volunteerService from '../../services/volunteerService';

const VolunteerList = () => {
  const [volunteers, setVolunteers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVolunteers = async () => {
      const response = await volunteerService?.getVolunteers();
      setVolunteers(response.data);
    };
    fetchVolunteers();
  }, []);

  return (
    <LayoutContainer>
      <AdminHeader title='Volunteers' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/volunteer/new')}
          >
            Add volunteer
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Reporting Head</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>Addhar Digit</TableCell>
              <TableCell>Photo</TableCell>
              {/* <TableCell>Description</TableCell> */}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {volunteers.map((volunteer, index) => (
              <TableRow
                key={volunteer.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                  // '&:hover': { backgroundColor: '#e0f7fa' },
                }}
              >
                <TableCell>{volunteer.name}</TableCell>
                <TableCell>{volunteer.reporting_head_name}</TableCell>
                <TableCell>{volunteer.vendor}</TableCell>
                <TableCell>{volunteer.phone}</TableCell>
                <TableCell>{volunteer.email}</TableCell>
                <TableCell>{volunteer.dob}</TableCell>
                <TableCell>{volunteer.aadharno}</TableCell>
                <TableCell>
                  <img
                    src={volunteer?.aadharphoto}
                    height={45}
                    width={50}
                    style={{ borderRadius: '100%' }}
                    alt={volunteer?.name}
                  />
                </TableCell>
                {/* <TableCell>{role.description}</TableCell> */}
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/volunteer/edit/${volunteer.id}`)}
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(role.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default VolunteerList;
